import { FC } from 'react';

import Button from 'design-system/components/Button';
import Stack, { HStack } from 'design-system/components/Stack';

interface HelpTextWithButtonProps {
  /**
   * URL to navigate to when the button is clicked
   */
  to: string;

  /**
   * Defaults to "Learn more"
   */
  buttonLabel?: string;
}

/**
 * Component for use within a tooltip to display help text with a button to learn more.
 */
const HelpTextWithButton: FC<HelpTextWithButtonProps> = ({
  children,
  to,
  buttonLabel = 'Learn more',
}) => {
  return (
    <Stack>
      {children}
      <HStack>
        <Button to={to} variant='basic' width='auto'>
          {buttonLabel}
        </Button>
      </HStack>
    </Stack>
  );
};

export default HelpTextWithButton;
